import { Activity, Settings, Target, Users } from 'lucide-react';
import { useState } from 'react';
import bloomsTaxonomy from '../../../constants/bloomTaxonomy';
import CompetencyConfigModal from '../CompetencyConfigModal/CompetencyConfigModal';
import ReassessmentModal from '../ReassessmentModal/ReassessmentModal';
import './InvestmentsTable.scss';

const InvestmentsTable = ({ executions, fetching }) => {
  const [revaluationButtonsVisible, setRevaluationButtonsVisible] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCompetency, setModalCompetency] = useState({ name: '', description: '', units: [], topicId: '', topic: {} });
  const [reassessmentOpen, setReassessmentOpen] = useState(false);
  const [reassessmentExecution, setReassessmentExecution] = useState(null);

  const getInvestmentConfigStatus = (execution) => {
    return execution?.topic?.skillKind ? true : false;
  };

  const handleOpenReassessment = (execution) => {
    setReassessmentExecution(execution);
    setReassessmentOpen(true);
  };

  const handleReassessmentSuccess = () => {
    setRevaluationButtonsVisible(prev => ({
      ...prev,
      [reassessmentExecution?.topic?.id]: false
    }));
  };

  return (
    <>
      <div className="InvestmentsTable-container">
        <div className="InvestmentsTable-scroll">
          <table className="InvestmentsTable">
            <thead>
              <tr className="InvestmentsTable-header-row">
                <th className="InvestmentsTable-header">Investimento</th>
                <th className="InvestmentsTable-header">Média da empresa</th>
                <th className="InvestmentsTable-header">Nível</th>
                <th className="InvestmentsTable-header">Aportes</th>
                <th className="InvestmentsTable-header">Investidores</th>
                <th className="InvestmentsTable-header">Ações</th>
              </tr>
            </thead>
            <tbody>
              {fetching && (
                <tr>
                  <td colSpan="6" className="InvestmentsTable-loading">
                    <div className="InvestmentsTable-dots">
                      <span className="InvestmentsTable-dot" />
                      <span className="InvestmentsTable-dot" />
                      <span className="InvestmentsTable-dot" />
                    </div>
                  </td>
                </tr>
              )}
              {!fetching && executions?.map((execution, key) => {
                const trackingAverage = execution?.tracking?.average || 0;
                const isConfigured = getInvestmentConfigStatus(execution);

                let taxonomyLabel = "Indefinido";
                if (typeof trackingAverage === 'number') {
                  for (const bloom of bloomsTaxonomy) {
                    const [min, max] = bloom.minimumGrade.split(' a ').map(v => parseFloat(v.replace(',', '.')));
                    if (trackingAverage >= min && trackingAverage <= max) {
                      taxonomyLabel = bloom.action.charAt(0).toUpperCase() + bloom.action.slice(1);
                      break;
                    }
                  }
                }

                return (
                  <tr
                    key={key}
                    className="InvestmentsTable-row"
                  >
                    <td className="InvestmentsTable-cell">
                      <div className="InvestmentsTable-cell-content">
                        <div className="InvestmentsTable-investment-info">
                          <div className="InvestmentsTable-investment-name">
                            {execution?.topic?.name}
                          </div>
                          {execution?.topic?.symbol && (
                            <div className="InvestmentsTable-investment-symbol">{execution?.topic?.description}</div>
                          )}
                        </div>
                        <div className="InvestmentsTable-investment-actions">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setModalCompetency({
                                name: execution?.topic?.name || '',
                                description: execution?.topic?.description || '',
                                units: execution?.topic.units || [],
                                topicId: execution?.topic?.id || '',
                                topic: execution?.topic || {}
                              });
                              setModalOpen(true);
                            }}
                            className="InvestmentsTable-settings-btn"
                          >
                            <Settings className="InvestmentsTable-icon-sm" />
                          </button>
                        </div>
                      </div>
                    </td>
                    <td className="InvestmentsTable-cell">
                      <div className="InvestmentsTable-cell-content">
                        <span className="InvestmentsTable-grade-value">
                          {execution?.tracking?.average ? execution.tracking.average.toFixed(1) : '0.0'}
                        </span>
                      </div>
                    </td>
                    <td className="InvestmentsTable-cell">
                      <span className="InvestmentsTable-badge">
                        {taxonomyLabel}
                      </span>
                    </td>
                    <td className="InvestmentsTable-cell">
                      <div className="InvestmentsTable-cell-content">
                        <Activity className="InvestmentsTable-icon" />
                        <span className="InvestmentsTable-count">
                          {execution?.popularity?.activeTasksCount || 0}
                        </span>
                      </div>
                    </td>
                    <td className="InvestmentsTable-cell">
                      <div className="InvestmentsTable-cell-content">
                        <Users className="InvestmentsTable-icon" />
                        <span className="InvestmentsTable-count">
                          {execution?.popularity?.affiliations || 0}
                        </span>
                      </div>
                    </td>
                    <td className="InvestmentsTable-cell">
                      {revaluationButtonsVisible[execution?.topic?.id] !== false && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleOpenReassessment(execution);
                          }}
                          className="InvestmentsTable-action-btn"
                        >
                          <span>Pedir Reavaliação</span>
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <CompetencyConfigModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        competencyName={modalCompetency.name}
        competencyInfos={modalCompetency.topic}
        competencyDescription={modalCompetency.description}
        units={modalCompetency.units}
        topicId={modalCompetency.topicId}
      />
      <ReassessmentModal
        isOpen={reassessmentOpen}
        onClose={() => setReassessmentOpen(false)}
        execution={reassessmentExecution}
        onSuccess={handleReassessmentSuccess}
      />
    </>
  )
}

export default InvestmentsTable
